module.exports = __webpack_public_path__ + "static/urs_aepli-e4c75603864b259e59e8e6e43e40cec4.png";